import React, { useEffect, Children } from 'react';
import { motion } from 'framer-motion';
import posthog from 'posthog-js';
export function Hero() {
  useEffect(() => {
    posthog.capture('homepage_loaded');
  }, []);
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 40
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1,
        ease: [0.19, 1, 0.22, 1]
      }
    }
  };
  return <section className="w-full px-6 md:px-12 min-h-[75vh] flex items-center pt-12 pb-24" data-id="element-26" data-mp="sarvuvlzhael">
      <div className="max-w-7xl mx-auto w-full" data-id="element-27" data-mp="ncgl8inv6vvb">
        <motion.div variants={container} initial="hidden" animate="show" className="max-w-5xl" data-id="element-28" data-mp="nboov5mg0u3z">
          <motion.h2 variants={item} className="text-hero-massive leading-[1.1] tracking-tight mb-8" data-id="element-29" data-mp="3d33fx1m3uzmc">
            <span className="text-ink text-[64px] font-semibold" data-id="element-30" data-mp="380vznzu8sxe7">
              Hello! I am Shihwen.
            </span>
          </motion.h2>

          <motion.p variants={item} className="tracking-tight text-stone-medium font-light text-[28px]" data-id="element-31" data-mp="3o7lvm11r3otp">
            I design intuitive products and distinctive experiences that help
            businesses grow—combining{' '}
            <span className="text-ink font-bold" data-id="element-32" data-mp="3e8mssz3o2nem">
              product thinking, visual craft, and systems thinking
            </span>
            .
          </motion.p>
        </motion.div>
      </div>
    </section>;
}